import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ApiUrlService } from 'src/app/shared/services/url.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ManageModuleService {
  itemsPerPage = 10;
  p: number = 1;
  
  constructor(private http: HttpClient, private apiUrlService: ApiUrlService) {}

  apiUrl = this.apiUrlService.getApiUrl();

  // Get all modules with pagination
  getAllModules(userId: string) {
    return this.http.post(
      `${this.apiUrl}/v1/modules?limit=${this.itemsPerPage}&page=${this.p}`,
      { userId }
    );
  }

  // Get module details by ID
  getModuleDetails(moduleId: number, userId: string) {
    return this.http.post(`${this.apiUrl}/v1/moduleDetails`, {
      moduleId,
      userId,
    });
  }

  // Create a new module
  createModule(moduleForm: any) {
    return this.http.post(
      `${this.apiUrl}/v1/createModule`,
      moduleForm
    );
  }

  // Update existing module
  updateModule(moduleForm: any) {
    return this.http.post(
      `${this.apiUrl}/v1/updateModule`,
      moduleForm
    );
  }

  // Delete module
  deleteModule(moduleId: number, userId: string) {
    return this.http.post(`${this.apiUrl}/v1/deleteModule`, {
      moduleId,
      userId,
    });
  }

  // Get module categories/types
  getModuleTypes() {
    return this.http.get(`${this.apiUrl}/v1/moduleTypes`);
  }

  // Get business lines
  getBusinessLines() {
    return this.http.get(`${this.apiUrl}/v1/businessLines`);
  }

  // Get regions
  getRegions() {
    return this.http.get(`${this.apiUrl}/v1/regions`);
  }

  // Filter modules
  getFilteredModules(filterValues: any) {
    return this.http.post(
      `${this.apiUrl}/v1/modulesFilter?limit=${this.itemsPerPage}&page=${this.p}`,
      filterValues
    );
  }

  // Toggle module status (active/inactive)
  setModuleStatus(userId: string, moduleId: number, status: string) {
    return this.http.post(`${this.apiUrl}/v1/setModuleStatus`, {
      userId,
      moduleId,
      status,
    });
  }

   onManageModuleDetailsFilter(filterValues: any,itemsPerPage:any,page:any) {
      return this.http.post(
        `${environment.apiUrl}/v1/filterManageModules?limit=${itemsPerPage}&page=${page}`,
        filterValues
      );
  }

}
